import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  TextField,
  Grid,
  Typography,
  Autocomplete,
  Switch,
} from "@mui/material";
import { Stack } from "@mui/system";
import DoneIcon from '@mui/icons-material/Done';
import { MetaEntitiesEndPointLogic } from "../../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useState } from "react";
import { setIsLoading, setUserToken } from "../../../../../features/userSlice";
import { useDispatch, useSelector } from "react-redux";
import SimpleBackdrop from "../../../../BackDrop/BackDrop";

interface TrafficSourceProps {
  open: boolean;
  handleClose: () => void;
}

function TrafficSourceModal({
  open,
  handleClose,
}: TrafficSourceProps) {

  const token = useSelector(setUserToken)
  const oauthTokenHeader = token?.payload?.user?.userToken;


  const [trafficSourceName, setTrafficSourceName] = useState(null);
  const [trafficSourceType, setTrafficSourceType] = useState(null);
  const [countAsClickInOut, setCountAsClickInOut] = useState(true);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

const CreateNewTrafficSource = async() => {
  const data = {
    traffic_source_name: trafficSourceName,
    traffic_type: trafficSourceType,
    count_as_click_in_out: countAsClickInOut
  };
  try {
    setIsLoading(true);
    setLoading(true);
    if (oauthTokenHeader) {
      await MetaEntitiesEndPointLogic.createMetaTrafficSource(oauthTokenHeader, data);
    } else {
      throw new Error("User doesn't have permissions to create new themes");
    }
    if(oauthTokenHeader) {
      setIsLoading(true);
      await MetaEntitiesEndPointLogic.getMetaTrafficSourceDuplicate(oauthTokenHeader,dispatch);
    }
  } catch (error) {
    console.error(error, "error");
  } finally {
    setIsLoading(false);
    setLoading(false);
    handleClose();
    setTrafficSourceName(null);
    await MetaEntitiesEndPointLogic.getMetaTrafficSourceDuplicate(oauthTokenHeader,dispatch);
  }
};

const handleCancel = () => {
  handleClose();
  setTrafficSourceName(null);
  setTrafficSourceType(null);
  setCountAsClickInOut(true);
}

  return (
    <>
      {loading ? (<SimpleBackdrop />):(
         <Dialog
         open={open}
         onClose={handleClose}
         PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
       >
         <Paper sx={{ padding: "16px 24px 20px 24px" }}>
           <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
           Create New Traffic Source
           </DialogTitle>
           <Typography sx={{mb:1}}>Details</Typography>
            <Grid container mt={0} columnSpacing={3}>
              <Grid item xs={6}>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Traffic Source Name *" // Set your label here
                  value={trafficSourceName}
                  onChange={(e: any) => setTrafficSourceName(e.target.value)}
                  placeholder="Enter unique Traffic Source Name" // Set your placeholder here
                  color="secondary"
                  size="small"
                  fullWidth
                />
              </Grid>
              <Grid item xs={6}>
                <Autocomplete
                  disablePortal
                  id="combo-box-demo"
                  options={["Paid", "Organic","Other"]}
                  sx={{ width: 400 }}
                  renderInput={(params) => <TextField {...params} label="Traffic Source Type" color="secondary"/>}
                  size="small"
                  onChange={(_, value:any) => setTrafficSourceType(value)}                 
                />
              </Grid>

              <Grid item xs={12} mt={2}>
                Include Clicks In Reports<Switch color="secondary" onChange={(e) => setCountAsClickInOut(e.target.checked)} checked={countAsClickInOut}/>
              </Grid>

            </Grid>
           <Typography
             sx={{ fontSize: "12px", marginTop: "8px", color: "#00000099" }}
           >
             This is a mandatory field.
           </Typography>
   
           <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
             <Button color="secondary" onClick={handleCancel} sx={{mr:1}}>
               CANCEL
             </Button>
             <Button
             variant="contained" 
             data-tracker="237"
             color="secondary"
             disabled={!trafficSourceName} 
             onClick={CreateNewTrafficSource}>
             Create <DoneIcon sx={{ml:1}} />
             </Button>
           </Stack>
         </Paper>
       </Dialog>
      )}
    </>
  );
}

export default TrafficSourceModal;
